import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { mapStateToProps } from "../../../redux/reducers";
import { connect } from "react-redux";
import * as actionType from "../../../redux/actionTypes/csaSignup";
import ModalComponent from "../../common/components/modal";
import { useForm } from "react-hook-form";
import { Col, Form,Row } from "react-bootstrap"
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import HelpIcon from '@mui/icons-material/Help';
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";


import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Divider,
  Grid,
  Checkbox,
  Box,
  FormControlLabel,
  Typography,
  Link,
  IconButton,
} from "@mui/material";
import ShareNestedFieldArray from "./share-nested-fieldArray";
import { popUpAlert } from "../../../utils/globalMethods";
import { twoDigitdecNum } from "../../../utils/globalMethods";
import { useParams } from "react-router-dom";
import CommonLoading from "../../common/components/commonLoading";
import { CustomButton } from "../../common/components/customButton";




let language = localStorage.getItem("selectedLanguage");
if (language === null) {
  language = "en-US";
}
let languageCode = language.substring(0, 2);

function SnapShareComponent(props) {

  let { agreementId, vendorId } = useParams();
  const navigate = useNavigate();
  let loginId = props?.userAuth?.user?.id;//searchParams.get("loginId");
  const [clientInfo, setClientInfo] = useState();
  const [sharePrecal, setSharePrecal] = useState();
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [data, setData] = useState('');
  const [showContent, setShowContent] = useState();
  const [showOne, setShowOne] = useState(false);
  const [showTwo, setShowTwo] = useState(false);
  const [showThree, setShowThree] = useState(false);
  const [shwoMnthlyTxt, setShowMnthlyTxt] = useState(false);
  const [mnthlyCost, setMnthlyCost] = useState();
  // eslint-disable-next-line no-unused-vars
  const [isLoggin] = useState(loginId ? true : false);
  // eslint-disable-next-line no-unused-vars 
  const [selectedAgrmntShr, setSelectedAgrmntShr] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isShareRowEdit, setIsShareRowEdit] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [popupShareId, setPopupShareId] = useState();
  const [allSharePrecal, setAllSharePrecal] = useState();
  const [isDaily, setIsDaily] = useState(false);
  const [language, setLanguage] = useState({});
  const { control, register, handleSubmit, watch, setValue, getValues, errors, reset } = useForm(
    {
      mode: "onBlur",
      defaultValues: {
        share: [
          {
            name: "",
            nestedArray: [{ nam: "", dsc: "", shareId: "", cost: "", type: "", minDate:"", maxDate:"", startDate: "", endDate: "" , isDisableDaily: false ,isDisableMonth: false}]
          }
        ]
      }
    }
  );

  // const formData = watch();
  const userRole = props?.userAuth?.user ? props?.userAuth?.user : JSON.parse(sessionStorage.getItem("userData"));

    useEffect(() => {
      setLanguage(props.signupLanguage)
    }, [props.signupLanguage]);

  useEffect(()=>{
    if (props.vendorChange) {
      setShowMnthlyTxt(false);
      setSharePrecal();
      setShowContent([]);      
    } else {
      setShowContent(props?.selectedShare);
      if (props?.shareGetValues && props?.shareGetValues?.share) {
        resetShare(props?.shareGetValues?.share);
      }
    }
    if (vendorId && props?.farmInfo?.farmDetails?.vendorId == vendorId) {
      if (props.csaSignup?.agrmntShareList?.agrmntShareList && props.csaSignup?.agrmntShareList?.agrmntShareList.length) {
        setSelectedAgrmntShr(props.csaSignup?.agrmntShareList?.agrmntShareList);
        props.csaSignup?.agrmntShareList?.agrmntShareList.forEach((item,i) => {
          setShowContent((preState) => ({
            ...preState,
            [item.shareId]: true
          }));
     
          // call precalculation api 
          const data ={
            id: item?.shareId,
            shareCost: item?.shareCost,
            startDate : item?.startDate,
            endDate: item?.endDate
          }
          setTimeout(()=>{
            handleCheckClick(data);
          },i * 1000);
        });
        // setTimeout(()=>{
          const ids = props.csaSignup?.agrmntShareList?.agrmntShareList.map(item=>item.shareId);
          setShowMnthlyTxt(ids.length);
          // const monthlyConst = props.csaSignup?.agrmntShareList?.agrmntShareList.map(item => item.shareCost).reduce((partialSum, a) => partialSum + a, 0);
          //   setMnthlyCost(monthlyConst);

            let updatedShare =  getValues()['share'].filter(item => {
              const nestShareId = item.nestedArray.map(i => i.shareId);
              return nestShareId.some(shareId => ids.includes(shareId));
            });
            const nestedShare = [];
              updatedShare.forEach(item => {
                if ( item.nestedArray.length > 1 ) {
                    item.nestedArray.forEach(i => nestedShare.push(i)); 
                } else {
                    nestedShare.push(item?.nestedArray[0]);
                }
              });

              const updatedMonthlyCost = nestedShare.filter(i => i.type==2)
                                            .filter((i) => {
                                              let nextMonth = getNextMonth();
                                              let startMonth = new Date(i.startDate).getMonth();
                                              return startMonth == nextMonth;
                                            })
                                        .map(item => {
                                          return parseFloat(item?.cost)
                                        })
                                        .reduce((partialSum, a) => partialSum + a, 0);
              const agreementShareCost =  props.csaSignup?.agrmntShareList?.agrmntShareList.filter((i) => {
                                              let nextMonth = getNextMonth();
                                              let startMonth = new Date(i.startDate).getMonth();
                                              return startMonth == nextMonth;
                                            }).map(item => item.shareCost).reduce((partialSum, a) => partialSum + a, 0);
              const monthlyCost = updatedMonthlyCost > 0 ? updatedMonthlyCost : agreementShareCost ;
              setMnthlyCost(monthlyCost);
              props.setTotalShareCost(monthlyCost);
        // },500);
      } else {
        setSelectedAgrmntShr([]);
      }
    } 
  },[props.vendorChange,props?.selectedShare,props.csaSignup?.agrmntShareList]);

  useEffect(()=>{
    setSharePrecal(props?.sharePrecal);
  },[props?.sharePrecal]);

  useEffect(() => { 
    setClientInfo(props?.clientInfo);   
    if (props?.clientInfo?.apiId) {  // check if client info is changed, if changed need to undo the share selection
      if (props?.sharePrecal && Object.keys(props?.sharePrecal).length !== 0 ) {
        const isSameClientId  = Object.values(props?.sharePrecal)?.[0]?.[0]?.clientId == props?.clientInfo?.apiId;
        if (!isSameClientId) {
          setSharePrecal();
          setShowContent([]);  
          props.setSharePrecal({});
        }
      } 
    }
  }, [props?.clientInfo]);

  const snapCsaContent = () => {
    setShowOne(!showOne);
  };
  const hipContent = () => {
    setShowTwo(!showTwo);
  };

  const Estimated = () => {
    setShowThree(!showThree);
  };

  useEffect(() => {
    if (props?.farmInfo?.farmDetails?.vendorId == vendorId) {
      if (agreementId) {
        const payload = { agreementId };
        props.getClientAgrmntShrLst(payload);
      }
    }
  }, [agreementId,props?.farmInfo?.farmDetails?.vendorId]);

  useEffect(() => {
    const payload = {
      "vendorId": props?.farmInfo?.farmDetails?.vendorId
    }
    props.getCSAShareList(payload);
  }, [props?.farmInfo?.farmDetails?.vendorId]);

  const handleButtonClick = (data) => {
    // while share details edit in admin signup
    if (isShareRowEdit && Object.keys(isShareRowEdit).length) {
      const isShareNotSave = Object.values(isShareRowEdit).some(item => item === true);
      if (isShareNotSave) {
        popUpAlert({
          text: 'Please save the edited Share Information',
          icon: 'warning',
          timer: '2500'
        });
        return false;
      } 
    }
    if(isDaily) {
      return false;
    }
    
    setIsSubmit(true);
    props.setVendorChange(false);
    submitShareForm(data,true);
    props.setAllSharePrecal(allSharePrecal);
  }

  const getSelectedShares = (data) => {
    const ids = Object.keys(showContent).filter(k => showContent[k] === true);
    const shares = props.csaSignup?.shareList?.shareList.filter(item => ids.indexOf(item.id.toString()) !== -1);
      // if (isLoggin) {
      if (userRole.Role === "ADMIN") {
        const updatedShare = data.share.filter(item => ids.indexOf(item?.shareId) !== -1);
        shares.map((item, i) => {
          item.nestedArray = updatedShare[i]?.nestedArray;
          return item;
        });
        props.shareDetails(shares);
      } else {
        props.shareDetails(shares);
      }      
      return shares;
  }

  const submitShareForm=(data, isSubmit, isRequestHelp)=>{

    const value = Object.values(showContent);
    let isShareSelected = arr => arr.some(Boolean);
    if (!isShareSelected(value) && (isSubmit || isRequestHelp)) { // || !precalCheck
      setIsError(true);
      setErrorMsg(language.snapShareErroMsg);

    } else {
      setIsError(false);

      const selectedShare =  Object.keys(showContent).map(item => {
        if (showContent[item]) {
          return item;
        }
      });
      const allSharePrecalList = [];
      selectedShare.forEach(item => {
          if (sharePrecal?.[item]?.length) {
              sharePrecal?.[item]?.forEach(i => {
                allSharePrecalList.push(i);
              });
          } 
      });
      
      const isDataInfoEmpty = allSharePrecalList.length === 0; 
      const isPaymentInfoEmpty = isDataInfoEmpty || allSharePrecalList.find(item => item?.paymentInfo?.length === 0);
      
      const shares = getSelectedShares(data);

      props.setShareGetValues(getValues());
      props.setSelectedShares(showContent);

      props.setSharePrecal(sharePrecal);
      props.setCSAFormValidate((prevState) => ({
        ...prevState,
        snap_csa: true
      }));

      if (isPaymentInfoEmpty && userRole.Role === "ADMIN") {
        setIsError(true);
        setErrorMsg("Please check the payment information which is empty");
        return false;
      } else {
        setIsError(false);        
        if (userRole.Role !== "ADMIN" && (isSubmit || isRequestHelp)) {  //if (!isLoggin && isSubmit)
          const hipSnapAmt = props?.farmInfo?.farmDetails?.isHIPVendor == "Y" ? clientInfo?.snapAmount + clientInfo?.hipAmount : clientInfo?.snapAmount;          
          if (isPaymentInfoEmpty || mnthlyCost > hipSnapAmt || isRequestHelp) {
            submitAlert(shares);
            setIsSubmit(true);
            return false;
          }
        }

        if (isSubmit) {
          props.setActiveTab("menuStep4");
        }

        // props.setShareGetValues(getValues());
        // props.setSelectedShares(showContent);
        // props.setSharePrecal(sharePrecal);
        // props.setCSAFormValidate((prevState) => ({
        //   ...prevState,
        //   snap_csa: true
        // }));
      }
    }
  }

  const submitAlert = (shares) => {
    popUpAlert({
      text: language.RequestHelpPopup,
      icon: 'info',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: language.Yes,
      cancelButtonText: language.No,
      onConfirmed: true,
      handleConfirm: () => {
        saveCSASignup(shares)
      }
    });
  }

  const saveCSASignup = (data) => {
    const share = [];
    let totalShrCost = 0;
    if (data.length) {
      data.forEach((item, i) => {
        const startDate = moment(item?.startDate) < moment() ? moment() : moment(item?.startDate);
        const date1 = startDate;
        const date2 = moment(item?.endDate);
        const diff = date2?.diff(date1, 'months');
        totalShrCost = totalShrCost + item?.shareCost;
        const shareObj = {
          "index": i + 1,
          "shareId": item?.id,
          "shareName": item?.nam,
          "dsc": item?.dsc,
          "dlvryFlg": item?.dlvryFlg,
          "shareSelected": [
            {
              "duration": diff + " Month(s)",
              "shareStartDate": disableMonth(startDate,item.endDate,item.type) ? dayjs().format("MM/DD/YYYY"): skipMonth2(startDate,item.type),
              "shareEndDate": (disableMonth(startDate,item.endDate,item.type) ? dayjs().format("MM/DD/YYYY") : dayjs(item.endDate).format('MM/DD/YYYY')),
              "paymentType": "MNTHLY",
              "submittedBy": "CLIENT",
              "determinedAmount": item?.shareCost,
            }
          ],
          "submittedBy": "CLIENT"
        }
        share.push(shareObj);
      });
    }

    let role = "";
    if (userRole?.Role === "ADMIN") {
        role = "ADM_";
    }

    const timestamp = new Date().getTime();
    const systemInfo = sessionStorage.getItem("systemInfo");
    const systemData = JSON.parse(systemInfo);
    const csaSignupForm = {
      "apid": clientInfo?.apid,
      "dob": clientInfo?.dob,
      "email": clientInfo?.email,
      "farmDetails": props?.farmInfo?.farmDetails,
      "firstName": clientInfo?.firstName,
      "hhSize": clientInfo?.hhSize,
      "languageCode": "en",
      "lastName": clientInfo?.lastName,
      "chosenName": clientInfo?.chosenNam,
      "clientPreferdEmail": clientInfo?.email ? clientInfo?.email : "",
      "clientPreferdPhone": clientInfo?.phoneno ? clientInfo?.phoneno?.replace(/\D/g, '') : "",
      "panNumber": clientInfo?.panNumber,
      "phoneNumber": clientInfo?.phoneNumber,
      "shareDetails": share,
      "totalAmount": totalShrCost,
      "totalShareAmountBalance": 0,
      "snapAmount": clientInfo?.snapAmount,
      "hipAmount": clientInfo?.hipAmount,
      "totalShareAmountPaid": totalShrCost,
      "lastUpdtUidNam": userRole?.Role === "ADMIN" ? role+userRole?.id : "CSASGNUP",
      "createTimeStamp": timestamp,
      "lastUpdtTimeStamp": timestamp,
      "ipAddress": systemData.ip
    };
    props.saveCSASignup(csaSignupForm);
  };

  const errorRef = useRef(null);

useEffect(() => {
  if (errorMsg && errorRef.current) {
    errorRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }
}, [errorMsg]);

  useEffect(() => {
    if (props.csaSignup?.saveCSASignup?.code == "200") {
      const payload = {
        "clientNam": clientInfo?.firstName + " " + clientInfo?.lastName,
        "isNeedHelp": "Y",
        "vendorName": props?.farmInfo?.farmDetails?.farmName
      }
      props.getRequestHelp(payload);
      
    }
  }, [props.csaSignup?.saveCSASignup]);

  useEffect(() => {
    if (isSubmit) {
      if (props.csaSignup?.requestHelp?.requestHelp?.code === "200") {
        popUpAlert({
          text: 'Mail sent successfully',
          icon: 'success',
          timer: '1000'
        });
        setTimeout(() => {
          navigate('/');
        }, 1001);
      }
      setIsSubmit(false);
    }
  }, [props.csaSignup?.requestHelp?.requestHelp]);

  useEffect(() => {
    setIsLoading(false);
    if (props.csaSignup?.snapShare && props.csaSignup?.snapShare?.snapShare) {
      setSharePrecal((prevState) => ({
        ...prevState,
        [props.csaSignup?.snapShare?.snapShare[0]?.shareId]: props.csaSignup?.snapShare?.snapShare
      }));
      
      setAllSharePrecal((prevState)=>({
        ...prevState,
        [props.csaSignup?.snapShare?.snapShare[0]?.shareId]: props.csaSignup?.snapShare?.snapShare
      }));
    }
  }, [props.csaSignup?.snapShare])

  const   handleCheckClick = (data) => {
    const payloadOne = { // monthly
      "clientId": props?.clientInfo?.apid,
      "shareId": data?.id,
      "shareStartDate": disableMonth(data.startDate,data.endDate,data.type) ? dayjs().format("MM/DD/YYYY"): skipMonth2(data.startDate,data.type),
      "shareEndDate": (disableMonth(data.startDate,data.endDate,data.type) ? dayjs().format("MM/DD/YYYY") : dayjs(data.endDate).format('MM/DD/YYYY')),
      "paymentType": data.type == 1 ? "DAILY": disableMonth(data.startDate,data.endDate,data.type) ? "DAILY" : "MNTHLY",//"MNTHLY",
      "determinedAmount": data?.shareCost,
      "submittedBy": userRole.Role === "ADMIN" ? "ADMIN" : "CLIENT"
    }
    const payloadArray = [payloadOne];
    props.getSnapShare(payloadArray);
  }

  const handleCheckClickTwo = () => {
    const payload = {
      "clientNam": clientInfo?.firstName + " " + clientInfo?.lastName,
      "isNeedHelp": "Y",
      "vendorName": props?.farmInfo?.farmDetails?.farmName
    }
    props.getRequestHelp(payload);
    popUpAlert({
      text: 'Mail sent successfully',
      icon: 'success',
      timer: '1000'
    })

  }

  useEffect(() => {
    const {loading} = props?.csaSignup?.shareList;
    setData(props.csaSignup?.shareList?.shareList);
    // if (!props?.shareGetValues?.share || (vendorId && props?.farmInfo?.farmDetails?.vendorId != vendorId)) {
    if (props.vendorChange || !props?.shareGetValues?.share || (vendorId && props?.farmInfo?.farmDetails?.vendorId != vendorId)) {
      setTimeout(() => {
        resetShare();
        setIsLoading(loading);
      }, 300);
    }
  }, [props.csaSignup?.shareList?.shareList])

  // const disableMonth = (startDate, endDate) => {
  //   return dayjs(startDate).isAfter(dayjs(endDate));
  // }

  const resetShare =(selectedShareData=null)=>{
    const arr = [];
    const shareData = selectedShareData ? [...selectedShareData] : [...props.csaSignup?.shareList?.shareList];
    shareData?.forEach((item) => {
      const obj = {
        id: item?.id,
        name: "",
        nestedArray: item?.nestedArray || [
          { nam: item?.nam, dsc: item?.dsc, shareId: item?.id, cost: item?.shareCost, 
          type: disableMonth(item.startDate,item.endDate,item.type) ? 1 : 2,        
          startDate: disableMonth(item.startDate,item.endDate,item.type) ? dayjs().format("MM/DD/YYYY"): skipMonth2(item.startDate, item.type),
          endDate:  disableMonth(item.startDate,item.endDate,item.type) ? dayjs().format("MM/DD/YYYY") : dayjs(item?.endDate).endOf('month').format("MM/DD/YYYY"),

          minDate: disableMonth(item.startDate,item.endDate,item.type) ? dayjs(item.startDate).format("MM/DD/YYYY"): skipMonth2(item.startDate ,item.type),
          maxDate: disableMonth(item.startDate,item.endDate,item.type) ? dayjs(item?.endDate).format("MM/DD/YYYY") : dayjs(item?.endDate).endOf('month').format("MM/DD/YYYY"),
          isDisableDaily: isDisableFuture(item.startDate),
          isDisableMonth: disableMonth(item.startDate,item.endDate,item.type)
          // maxDate: (dayjs(item?.endDate) < dayjs() ?  dayjs().endOf('month').format("MM/DD/YYYY") :  dayjs(item?.endDate).endOf('month').format("MM/DD/YYYY")),
        },
      ]
      };
      arr.push(obj);
    });
    const defaultValues = {
      share: arr
    };
    reset(defaultValues);
  };

  const openSweetAlert = () => {
    submitShareForm(getValues(), false, true);
    // popUpAlert({
    //   text: language.RequestHelpPopup,
    //   icon: 'info',
    //   showCancelButton: true,
    //   showConfirmButton: true,
    //   confirmButtonText: language.Yes,
    //   cancelButtonText: language.No,
    //   closeOnConfirm: false,
    //   onConfirmed: true,
    //   handleConfirm:()=> handleCheckClickTwo()      
    // });
  };


  const formatemonth = (item) => {
    return moment(item).format('MMM YYYY');
  }

  const getNextMonth = () => {
    const today = new Date();
    const nextMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        1
      );
    return nextMonth.getMonth();
  }

  useEffect(() => {
    if (showContent) {
      const ids = Object.keys(showContent).filter(k => showContent[k] === true);
      setShowMnthlyTxt(ids.length);
      const shares = props.csaSignup?.shareList?.shareList.filter(item => ids.indexOf(item.id.toString()) !== -1);
      let updatedShare = getValues()['share'].filter(item => ids.indexOf(item?.id?.toString()) !== -1);      
      const nestedShare = [];
      updatedShare.forEach(item => {
        if ( item.nestedArray.length > 1 ) {
            item.nestedArray.forEach(i => nestedShare.push(i)); 
        } else {
            nestedShare.push(item?.nestedArray[0]);
        }
      });

      const updatedMonthlyCost = nestedShare.filter(i => i.type==2)
                                            .filter((i) => {
                                              let nextMonth = getNextMonth();
                                              let startMonth = new Date(i.startDate).getMonth();
                                              return startMonth == nextMonth;
                                            })
                                            .map(item => {
                                              return parseFloat(item?.cost);
                                            })
                                            .reduce((partialSum, a) => partialSum + a, 0)?.toFixed(2);

      const actualShareCost = shares.filter((i) => {
                                        let nextMonth = getNextMonth();
                                        let startMonth = new Date(i.startDate).getMonth();
                                        return startMonth == nextMonth;
                                      })
                                    .map(item => item.shareCost)
                                    .reduce((partialSum, a) => partialSum + a, 0);

      const monthlyCost =  updatedMonthlyCost > 0 ? updatedMonthlyCost : actualShareCost;
      props.setTotalShareCost(monthlyCost)
      setMnthlyCost(monthlyCost);
      // setIsLoading(true);
    }
  }, [showContent,props.csaSignup?.shareList]);


  const calcMnthlyCost = ()=>{
    const ids = Object.keys(showContent).filter(k => showContent[k] === true);
    // const monthlyConst =  getValues()['share'].filter(item =>ids.indexOf(item.id.toString()) !== -1)
    //                       .map(item => parseFloat(item.nestedArray[0].cost)).reduce((partialSum, a) => partialSum + a, 0);
    let updatedShare = getValues()['share'].filter(item => ids.indexOf(item?.id?.toString()) !== -1);
    const nestedShare = [];
      updatedShare.forEach(item => {
        if ( item.nestedArray.length > 1 ) {
            item.nestedArray.forEach(i => nestedShare.push(i)); 
        } else {
            nestedShare .push(item?.nestedArray[0]);
        }
      });
      const monthlyCost = nestedShare.filter(i => i.type==2)
                                      .filter((i) => {
                                              let nextMonth = getNextMonth();
                                              let startMonth = new Date(i.startDate).getMonth();
                                              return startMonth == nextMonth;
                                            })
                                      .map(item => {
                                        return parseFloat(item?.cost)
                                      })
                                      .reduce((partialSum, a) => partialSum + a, 0)?.toFixed(2);
    setMnthlyCost(monthlyCost);
    props.setTotalShareCost(monthlyCost);
  };

  const getShareName = (item) => {
    let nam = item.nam;
    if (item.multiLang && item.multiLang.length) {
      nam = item.multiLang.find(lang=>lang.lang === languageCode)?.nam;
      if (!nam) {
        nam = item.nam;
      }
    }
    return nam;
  };

  const getShareDsc= (item) => {
    let dsc = item.dsc;
    if (item.multiLang && item.multiLang.length) {
      dsc = item.multiLang.find(lang=>lang.lang === languageCode)?.dsc;
      if (!dsc) {
        dsc = item.dsc;
      }  
    }
    return dsc;
  };
// eslint-disable-next-line no-unused-vars
  const shouldDisableCheckbox = (startDate, endDate) => {
    const start = dayjs(startDate);
    const end = dayjs(endDate);
  

    const startMonth = start.month();
    const endMonth = end.month();
    const startYear = start.year();
    const endYear = end.year();
  
   
    return startYear === endYear && dayjs(startMonth).isAfter(endMonth);
  };
  const renderModal = () => {
    return (
      <Grid>
        {sharePrecal && sharePrecal?.[popupShareId] && sharePrecal?.[popupShareId].map((item, i) => (
          <div key={i}>
            {item &&
              <Box sx={{
                marginTop: '10px',
                marginBottom: "10px",
                width: '100%',
                padding: '10px',
              }}>
                <Grid sx={{ borderRadius: "5px", backgroundColor: "#DBE8DF", fontSize: "20px", fontFamily: 'Texta-bold', marginLeft: '10px', padding: '18px' }}>
                  <Typography sx={{ fontWeight: "bold", fontSize: "20px", fontFamily: 'Texta-bold' }}>Share Details - {item?.paymentType.toUpperCase() === "DAILY" ? "Daily Share" : "Monthly Share"}</Typography><br />
                  <Typography sx={{ fontSize: "20px", fontFamily: 'Texta-book' }}>
                    CSA Start Month: {item?.paymentInfo?.[0]?.paymentDate ? formatemonth(item?.paymentInfo?.[0]?.paymentDate) : formatemonth(item?.shareStartDate)} | CSA End Month : {item?.paymentInfo?.[item?.paymentInfo?.length - 1]?.paymentDate ? formatemonth(item?.paymentInfo?.[item?.paymentInfo?.length - 1]?.paymentDate) : formatemonth(item?.shareEndDate)} |
                    {item?.paymentType.toUpperCase() === "DAILY" ? " Daily" : " Monthly"} Share Cost: ${item?.paymentInfo?.[0]?.paymentAmount ? item?.paymentInfo?.[0]?.paymentAmount : 0}
                  </Typography>
                  <br />
                  <Typography sx={{ fontWeight: "bold", fontSize: "20px", fontFamily: 'Texta-bold' }}> Your CSA Payment Schedule </Typography> <br />
                  <Table sx={{ border: "1px solid",maxWidth: "50%", '@media (max-width: 768px)': { maxWidth: "100%" }}}>
                          <TableRow sx={{ border: '1px 0px  2px 0px solid #535954', fontSize: "20px !important" }}>
                            <TableCell className="payment-label" sx={{ border: "1px  solid", fontFamily: 'Texta-book', fontSize: '19px', fontWeight: 'bold', lineHeight: '1.5px','@media (max-width: 768px)': { fontSize: "14px !important" } }}>
                              Payment Date
                            </TableCell>
                            <TableCell className="payment-label" sx={{ border: "1px  solid", fontSize: "19px !important", fontFamily: 'Texta-book', fontWeight: 'bold', lineHeight: '1.5px','@media (max-width: 768px)': { fontSize: "14px !important" } }}>
                              Payment Amount
                            </TableCell>
                          </TableRow>
                    {item?.paymentInfo?.length ?                      
                      <> 
                        {item?.paymentInfo?.map((item, i) => (
                        <TableRow key={i} sx={{ border: "1px solid", fontSize: "20px", fontFamily: 'Texta-book' }}>
                          <TableCell sx={{ border: "1px solid", fontFamily: 'Texta-book', fontSize: '19px !important', lineHeight: '1.5px' }}>
                            {item.paymentDate}
                          </TableCell>
                          <TableCell sx={{ border: "1px solid", fontFamily: 'Texta-book', fontSize: '19px !important', lineHeight: '1.5px' }}>
                            ${twoDigitdecNum(item.paymentAmount)} {i === 0 &&
                              <IconButton className="tooltip" style={{ display: 'inline', fontSize:'14px', color:'black'}}><HelpIcon className="green-color cursor-pointer" />
                                <span className="tooltiptext">This payment schedule is estimated based on today&apos;s date. The CSA start date and payment schedule might happen later if the farm needs more time to process your CSA request.</span>
                              </IconButton>}

                          </TableCell>
                        </TableRow >))}
                      </> 
                    : ""}
                    <TableRow sx={{ border: "2px 1px 1px 1px solid", fontSize: "20px", fontFamily: 'Texta-book', lineHeight: '1.5px' }}>
                      <TableCell sx={{ border: "1px solid", fontFamily: 'Texta-book', fontSize: '19px !important', fontWeight: 'bold', lineHeight: '1.5px' }}>Overall Cost</TableCell>
                      <TableCell sx={{ border: "1px  solid", fontFamily: 'Texta-book', fontSize: '19px !important' }}> ${twoDigitdecNum(item?.totalAmount)}</TableCell>
                    </TableRow>
                  </Table>
                </Grid>
              </Box>}
          </div>
        ))}
        <Button variant="contained" className="followUp-Button" onClick={() => {
          setShowModal(false);
        }}>OK</Button>
      </Grid>
    )
  }


  const showPrecalculationDetails = (item) => {
    setShowModal(true);
    setPopupShareId(item.id);
    // callPreCal(item);
  };

const skipDay = (endDate) =>{
  const currentDate = dayjs().format("MM/DD/YYYY");
  const shareEndDate = dayjs(endDate).endOf('month').format("MM/DD/YYYY");
  if(shareEndDate > dayjs(currentDate).add(2,"day")) {
    return currentDate.format("MM/DD/YYYY")
  }
}

const skipMonth2 = (startDate, type) => {
    
  const currentDate = dayjs();
  
  if (type == 1) {
      
      return dayjs(startDate).isBefore(currentDate) 
          ? currentDate.format("MM/DD/YYYY") 
          : dayjs(startDate).format("MM/DD/YYYY");
  } else {
      
      let addntMnth = currentDate.date() > 26 ? 2 : 1;
      const newMonth = currentDate.startOf('month').add(addntMnth, 'month');
      const startMonth = dayjs(startDate).startOf('month');

      return newMonth.isBefore(startMonth) 
      ? startMonth.startOf('month').format("MM/DD/YYYY") 
      : newMonth.startOf('month').format("MM/DD/YYYY")
  }
}

  const newStartDate = skipMonth2();

  const disableMonth = (startDate, endDate, type) => {
    const newStartDate = skipMonth2(startDate, type);
    return dayjs(newStartDate).isAfter(dayjs(endDate).format("MM/DD/YYYY"));
  };



  const isDisableFuture =(date) => {
    let startDate = dayjs(date).startOf('month')
     return dayjs(startDate) >= dayjs();
  } 
    
  // const isDisablePast = (date) => {
  //   const currentDate = dayjs();
  //   const endDate = dayjs(date).endOf('month')
  //   return dayjs(endDate).isBefore(currentDate.add(0, 'day'), 'day');
  // }


  const shouldDisableCheckboxNew = (startDate, endDate, type) => {
    if ((userRole.Role === "ADMIN")) {
      let curdte = dayjs().format("MM/DD/YYYY");
      let shareEndDate = dayjs(endDate).format("MM/DD/YYYY");
           return disableMonth(startDate, endDate, type) && (dayjs(curdte).isAfter(dayjs(shareEndDate)));
    } else {
      return disableMonth(startDate, endDate, type);
    }
  };

  const callPreCal = (item)=>{
    const shares = getValues()['share'];
    const matchingShare = shares.find(data => data.id == item.id);

    if (matchingShare) {
      const shareArr = matchingShare.nestedArray;

      const payloadArray = shareArr.map(share => ({
        "clientId": props?.clientInfo?.apid,
        "shareId": item.id,
        "shareStartDate": disableMonth(share.startDate,share.endDate,share.type) ? dayjs().format("MM/DD/YYYY"): skipMonth2(share.startDate,share.type),

        "shareEndDate": ( disableMonth(share.startDate,share.endDate,share.type) ? dayjs().format("MM/DD/YYYY") : dayjs(share.endDate).format('MM/DD/YYYY')),
        "paymentType": share.type == 1 ? "DAILY" : (disableMonth(share.startDate,share.endDate,share.type) ? "DAILY" : "MNTHLY"),
        "determinedAmount": share.cost,
        "submittedBy": userRole.Role === "ADMIN" ? "ADMIN" : "CLIENT"
      }));

      if (payloadArray && payloadArray.length > 0) {
        props.getSnapShare(payloadArray);
        setIsLoading(true);
      }
    } else {
      console.error('Matching share not found');
    }
  };




  return (
    
    <Form id="snap-share" onSubmit={handleSubmit(handleButtonClick)}>
      {showModal && !isLoading && <ModalComponent 
                shown={showModal}
                close={() => {
                    setShowModal(false);
                    // reset();
                }}
                title={"Precalculation"}
                modalBody={renderModal}
                size={"lg"}
                label={"PRECALCULATION"}
            />}
      <Grid item lg={12} md={12} ml={4} mt={7.2} className='wrapper-gird' sx={{ border: "1px solid #cccccc"}}>
        <Box>
          {isLoading && <CommonLoading />}
          <Box  sx={{ backgroundColor: '#EEEEEE', borderBottom: '1px solid #CCCCCC' }}>
          <Grid container item xs={12}>
              <Grid item xs={12} md={8}>
                <Typography variant="h3" className='sub-heading' tabIndex={0}>
                  {language.snapCSA}<br/><span style={{fontSize:'17px',marginBottom:'30px'}}>{language.howToUseThisPage}</span>
                </Typography>
              </Grid>
              <Grid item xs={12} md={4} pr={2} sx={{display:'flex',justifyContent:'end',alignItems:'center'}}>
              <Typography sx={{
                    color: 'white !important',  lineHeight: "1", textAlign: " center",
                   whiteSpace: "nowrap", verticalAlign: "baseline", backgroundColor: '#006e52',
                    borderRadius: "3px", padding: "0.25em 0.4em", width: "82", height: "10", display: "inline-block",cursor:'pointer',
                    marginBottom: "10px"
                  }}>
                  <Link  style={{fontFamily: "texta-bold" ,color: "white",fontSize: '19px', fontWeight: "700",textDecoration:"none"}} onClick={() => { window.open("https://www.youtube.com/watch?v=b0T7Qsc66ls") }} target="_blank" tabIndex={0}>
                    <i className="fa fa-play-circle" aria-hidden="true" />&nbsp;{language.snapCSAWorks}</Link>  </Typography>          
              </Grid>
            </Grid>
          </Box>
          <Row display={'flex'} sx={{ border: '1px solid rgba(0, 0, 0, 0.125)', borderTop: 'none', height: 'auto' }}>
            <Grid>
              <Grid sx={{ padding: "5px" }}>
                <TableCell
                  sx={{
                    // backgroundColor: "#EEEEEE",
                    fontSize: "20px",
                    borderRadius: "3px",
                    margin: '0px 0px 8px'
                  }}
                >

                  <Typography sx={{
                    fontFamily: 'Texta-book', fontSize: '21px', fontWeight: '400',
                    lineHeight: '1.5', color: '#212529', textAlign: 'left'
                  }}>
                    {language.PickA}{" "}
                    <Button onClick={snapCsaContent}
                      //  sx={{ color: "#006e52", backgroundColor: "#d4edda" }}
                      sx={{
                        color: 'white !important', fontSize: "90%", fontWeight: "bold", lineHeight: "1", textAlign: " center",
                        fontFamily: 'Texta-book', whiteSpace: "nowrap", verticalAlign: "baseline", backgroundColor: '#006e52 !important',
                        borderRadius: "3px", padding: "0.25em 0.4em", width: "82", height: "10", display: "inline-block",cursor:'pointer'
                      }}
                    >
                      {language.SnapCSAButton}</Button> {language.shareBelow}{" "}

                    <Button onClick={hipContent}
                      //  sx={{ color: "#006e52", backgroundColor: "#d4edda" }}
                      sx={{
                        color: 'white !important', fontSize: "90%", fontWeight: "bold", lineHeight: "1", textAlign: " center",
                        fontFamily: 'Texta-book', whiteSpace: "nowrap", verticalAlign: "baseline", backgroundColor: '#006e52 !important',
                        borderRadius: "3px", padding: "0.25em 0.4em", width: "82", height: "10", display: "inline-block",cursor:'pointer'
                      }}
                    >
                      {language.HIPButton}</Button>  {language.youGetEachMonth} </Typography>
                  <Typography sx={{
                    fontFamily: 'Texta-book', fontSize: '21px', fontWeight: '400',
                    lineHeight: '1.5', color: '#212529', textAlign: 'left'
                  }}>
                    {language.IfYouNeedHelp}
                  </Typography>

                  <Button onClick={openSweetAlert} tabIndex={0} sx={{ textTransform: 'none',
                    color: 'white !important', fontSize: "90%", fontWeight: "700", lineHeight: "1", textAlign: " center",
                    fontFamily: 'Texta-book', whiteSpace: "nowrap", verticalAlign: "baseline", backgroundColor: '#006e52 !important',
                    borderRadius: "3px", padding: "0.25em 0.4em", width: "82", height: "10", display: "inline-block",cursor:'pointer'
                  }}>
                    {language.RequestButton}
                  </Button>

                  <Typography sx={{
                    fontFamily: 'Texta-book', fontSize: '21px', fontWeight: '400',
                    lineHeight: '1.5', color: '#212529', textAlign: 'left'
                  }}>
                    {language.IfTheFarmSays}{" "}
                    <Button onClick={Estimated}
                      //  sx={{ color: "#006e52", backgroundColor: "#d4edda" }}
                      sx={{
                        color: 'white !important', fontSize: "90%", fontWeight: "bold", lineHeight: "1", textAlign: " center",
                        fontFamily: 'Texta-book', whiteSpace: "nowrap", verticalAlign: "baseline", backgroundColor: '#006e52 !important',
                        borderRadius: "3px", padding: "0.25em 0.4em", width: "82", height: "10", display: "inline-block",cursor:'pointer',
                        textTransform:'lowercase'
                      }}
                    >
                      {language.EstimatedButton}
                    </Button>.

                  </Typography>

                  {showThree && <Box sx={{ border: '1px', borderColor: 'green', backgroundColor: "#d4edda", transition: "transform 1s", marginTop: '20px', padding: '10px' }}><Typography sx={{ fontSize: '20px', fontFamily: 'Texta-book', color: "#155724" }}>
                    <Grid sx={{ display: 'flex', flexDirection: 'row' }}  tabIndex={0}>
                      <Grid sx={{ width: '95%' }}>{language.EstimatedComboBox} </Grid>
                      <Grid sx={{ marginLeft: '10px' }}><IconButton aria-label='close button' onClick={() => setShowThree(!showThree)}><CloseIcon /></IconButton></Grid>
                    </Grid>
                  </Typography></Box>}

                  {showOne && <Box sx={{ border: '1px', borderColor: 'green', backgroundColor: "#d4edda", transition: "transform 1s", marginTop: '20px', padding: '10px' }}><Typography sx={{ fontSize: '20px', fontFamily: 'Texta-book', color: "#155724" }}>
                    <Grid sx={{ display: 'flex', flexDirection: 'row' }} tabIndex={0}>
                      <Grid sx={{ width: '95%' }}> {language.snapCSAComboBox}</Grid>
                      <Grid sx={{ marginLeft: '10px' }}><IconButton aria-label='close button' onClick={() => setShowOne(!showOne)}><CloseIcon /></IconButton></Grid>
           
                    </Grid>
                  </Typography></Box>}

                  {showTwo && <Box sx={{ border: '1px', borderColor: 'green', backgroundColor: "#d4edda", transition: "transform 1s", marginTop: '20px', padding: '10px' }}><Typography sx={{ fontSize: '20px', fontFamily: 'Texta-book', color: "#155724" }}>
                    <Grid sx={{ display: 'flex', flexDirection: 'row' }} tabIndex={0}>
                      <Grid sx={{ width: '95%' }} > {language.hipComboBox} <Link tabIndex={0} sx={{cursor:'pointer',color:'#006e52',textDecorationColor:'#006e52'}} onClick={() => {window.open("https://www.mass.gov/massachusetts-hip-gives-you-money-back-when-you-use-your-snap-benefits-to-buy-healthy-local-fruits-and-vegetables-from-hip-farm-vendors")}}>mass.gov/HIP</Link>.</Grid>
                      <Grid sx={{ marginLeft: '10px' }}><IconButton aria-label='close button' onClick={() => setShowTwo(!showTwo)}><CloseIcon /></IconButton></Grid>
                    </Grid>
                  </Typography>
                  </Box>}
                </TableCell>
              </Grid>
            </Grid>
            <Row>
              <Col item xs={12} md={4}>
                <p className="text-center benefit_overlay">
                  {language.YourSnapMonthlyAmount} = ${twoDigitdecNum(clientInfo?.snapAmount)}
                </p>
              </Col>
              {props?.farmInfo?.farmDetails?.isHIPVendor === "Y" &&
                <Col item xs={12} md={4}>
                  <p className="text-center benefit_overlay">
                    {language.YourHIPMontlhyCap} = <span>${twoDigitdecNum(clientInfo?.hipAmount)}</span>
                  </p>
                </Col>
              }
              { userRole.Role === "ADMIN" &&  //isLoggin &&
                <Col item xs={12} md={4}>
                  <p className="text-center benefit_overlay">
                    Your EBT Balance = ${twoDigitdecNum(clientInfo?.ebtCardBalance)}
                  </p>
                </Col>
              }
            </Row>

            <Grid>
              {/* {isError && (<Typography component="span" className='dh-txt-danger' sx={{ fontSize: '18px', marginLeft: '18px' }}><i className="fa fa-info-circle"></i> Please choose the CSA share you would like to purchase</Typography>)} */}
              <Typography sx={{ fontSize: '18px', fontFamily: 'Texta-bold', marginLeft: '18px' }}>{language.PleaseCheckOff}</Typography>
              <Grid sx={{ marginBottom: "20px" }} item xs={12} sm={12} md={12}>
                {data && data.map((item, i) => (
                  <Grid key={i} sx={{ padding: "3px", marginLeft: '30px' }}>
                    <FormControlLabel sx={{ fontSize: "30px", fontFamily: 'Texta-bold', color: "#006e52", lineHeight: 1.3, fontWeight: 'bold',
                       '&:focus-visible': {
                          outline: '3px solid #005fcc',
                          outlineOffset: '2px'
                        }
                     }}
                      control={<Checkbox 
                        disabled={(!loginId && item?.shareStatus === "SLDOUT") || shouldDisableCheckboxNew(newStartDate, item.endDate, item.type)} 
                        checked={showContent?.[item.id] === true}
                        onClick={(e) => { 
                        setIsError(false);
                        // if (!isLoggin) {
                        //   handleCheckClick(item);
                        // }
                        
                        if (!e.target.checked) {
                          if (getValues()) {
                            const data = getValues()['share'].map(share =>{
                              if (item.id == share.id) {
                                share.nestedArray = [{ nam: item?.nam, dsc: item?.dsc, shareId: item?.id, cost: item?.shareCost, 
                                type: disableMonth(item.startDate,item.endDate,item.type) ? 1 : 2,
                                // startDate: skipMonth2(item.startDate, item.type),
                                // endDate:  item.type === "1" 
                                //     ? dayjs(item.endDate).format("MM/DD/YYYY") : dayjs(item?.endDate).endOf('month').format("MM/DD/YYYY"),
                                startDate: disableMonth(item.startDate,item.endDate,item.type) ? dayjs().format("MM/DD/YYYY"): skipMonth2(item.startDate, item.type),
                                endDate: disableMonth(item.startDate,item.endDate,item.type) ? dayjs().format("MM/DD/YYYY") : dayjs(item?.endDate).endOf('month').format("MM/DD/YYYY"),

                                minDate: disableMonth(item.startDate,item.endDate,item.type) ? skipDay(item?.endDate): skipMonth2(item.startDate ,item.type),
                                maxDate: disableMonth(item.startDate,item.endDate,item.type) ? dayjs().format("MM/DD/YYYY") : dayjs(item?.endDate).endOf('month').format("MM/DD/YYYY"),

                                isDisableDaily: isDisableFuture(item.startDate),
                                isDisableMonth: disableMonth(item.startDate,item.endDate,item.type)
                              }]
                              }
                              return share;
                            });
                            const defaultValues = {
                              share: data
                            };
                            reset(defaultValues);
                            setIsShareRowEdit();
                            setIsDaily();
                          }
                        } 
                        else {
                          if (item) {
                            // if (!loginId) {
                              setIsLoading(true);
                            // }                       
                            const data ={
                              id: item?.id,
                              shareCost: item?.shareCost,
                              startDate : item?.startDate,
                              endDate: item?.endDate,
                              type: item.isDisableMonth ? 1 : 2
                            }
                            handleCheckClick(data);
                          }
                          // callPreCal({id:item.id });
                        }
                        setShowContent((prevState) => ({
                          ...prevState,
                          [item.id]: e.target.checked
                        }));
                      }} />}
                      label= {
                      <div className="heading-text" aria-label={`Share cost and share name is ${"$" + twoDigitdecNum(item.shareCost) + '-' + getShareName(item) + " "}`}>
                      {"$" + twoDigitdecNum(item.shareCost) + '-' + getShareName(item) + " "}
                      {item?.shareStatus === "SLDOUT" ? (<span className="badge badge-danger-snap">Sold Out</span>) : ""}

                    </div>}

                    />
                      
                        
                      <Typography className="heading-sub-text" component={"p"}><span className="sr-only">share description is</span>
                      {/* <span className="share-desc" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(getShareDsc(item)) }} /> */}
                      {getShareDsc(item)}
                      </Typography>
                    {userRole.Role === "ADMIN" &&  showContent?.[item.id] &&  //isLoggin  
                      <Grid xs={12}>
                      <ShareNestedFieldArray nestIndex={i} shareInfo={item} 
                      setPreCalc={(preCalc)=>{
                        if (preCalc) {
                          // const data ={
                          //   id: preCalc?.shareId,
                          //   shareCost: preCalc?.cost,
                          //   startDate : preCalc?.startDate,
                          //   endDate: preCalc?.endDate,
                          //   type: preCalc?.type
                          // }
                          // handleCheckClick(data);
                          calcMnthlyCost();
                        }
                      }} 
                      triggerPrecal={(item)=>callPreCal(item)}
                      setIsShareRowEdit={setIsShareRowEdit} setIsDaily= {setIsDaily} isDaily={isDaily} {...{ control, register, setValue, getValues, watch, errors }} />

                      <CustomButton variant="contained" sx={{mt:2}} onClick={() => showPrecalculationDetails(item)}>
                        show precalculation
                      </CustomButton>
                    </Grid>
                    }

                    {showContent?.[item.id] && userRole.Role !== "ADMIN" &&  //!isLoggin &&
                    <Box sx={{
                      marginTop: '10px', marginBottom: "10px", width: '788px', padding: '3px', marginLeft: '-10px',
                      '@media (max-width: 768px)': {
                          width: '100%',
                       }
                    }}>
                      <Grid item xs={12} sx={{ borderRadius: "5px", backgroundColor: "#DBE8DF", fontSize: "20px", fontFamily: 'Texta-bold', marginLeft: '10px', padding: '18px' }}>
                        <Typography sx={{ fontWeight: "bold", fontSize: "20px", fontFamily: 'Texta-bold' }}>{language.ShareDetails}</Typography><br />
                        <Typography sx={{ fontSize: "20px", fontFamily: 'Texta-book' }}>
                          {language.CSAStartMonth}{sharePrecal?.[item.id]?.[0]?.paymentInfo[0]?.paymentDate ? formatemonth(sharePrecal?.[item.id]?.[0]?.paymentInfo[0]?.paymentDate) : "-"} | {language.CSAEndMonth}{sharePrecal?.[item.id]?.[0]?.paymentInfo[sharePrecal?.[item.id]?.[0]?.paymentInfo.length -1]?.paymentDate ? formatemonth(sharePrecal?.[item.id]?.[0]?.paymentInfo[sharePrecal?.[item.id]?.[0]?.paymentInfo.length -1]?.paymentDate) : "-"} |
                          {language.MonthlyShareCost} ${sharePrecal?.[item.id]?.[0]?.paymentInfo?.[0]?.paymentAmount ? sharePrecal?.[item.id]?.[0]?.paymentInfo?.[0]?.paymentAmount : 0}
                        </Typography>
                        <br />                        
                        <Table sx={{ border: "1px solid",maxWidth: "50%", '@media (max-width: 768px)': { maxWidth: "100%" }, captionSide: 'top'}}>
                          <caption style={{captionSide: 'top', fontWeight: "bold", fontSize: "20px", fontFamily: 'Texta-bold'}}> {language.YourCSAPaymentSchedule} </caption>
                          <TableHead sx={{ border: '1px 0px  2px 0px solid #535954', fontSize: "20px !important" ,'@media (max-width: 768px)': { fontSize: "16px !important" }}}>
                            <TableRow>
                              <TableCell className="payment-label" sx={{ border: "1px  solid", fontFamily: 'Texta-book', fontSize: '18px', fontWeight: 'bold', lineHeight: '1.5px' }}>
                                {language.PaymentDate}
                              </TableCell>
                              <TableCell className="payment-label" sx={{ border: "1px  solid", fontSize: "18px !important", fontFamily: 'Texta-book', fontWeight: 'bold', lineHeight: '1.5px' }}>
                                {language.PaymentAmount}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          {sharePrecal?.[item.id]?.[0]?.paymentInfo.map((item, i) => (

                            <TableRow key={i} sx={{ border: "1px solid", fontSize: "20px", fontFamily: 'Texta-book' }}>
                              <TableCell sx={{ border: "1px solid", fontFamily: 'Texta-book', fontSize: '19px !important', lineHeight: '1.5px' }}>
                                {item?.paymentDate}
                              </TableCell>
                              <TableCell className={i === 0 ? "payment-tooltip" : ""} sx={{ border: "1px solid", fontFamily: 'Texta-book', fontSize: '19px !important', lineHeight: '1.5px' }}>
                                ${twoDigitdecNum(item?.paymentAmount)}
                                {i === 0 &&

                                  <IconButton aria-label={language.ThisPaymentSchedule} style={{fontSize:'14px', color:'black'}} className="tooltip" tabIndex={0}><HelpIcon className="green-color cursor-pointer" />
                                    <span className="tooltiptext">{language.ThisPaymentSchedule}</span>
                                  </IconButton>
                                  }
                              </TableCell>
                            </TableRow >
                          ))}
                          <TableRow sx={{ border: "2px 1px 1px 1px solid", fontSize: "20px", fontFamily: 'Texta-book', lineHeight: '1.5px' }}>
                            <TableCell sx={{ border: "1px solid", fontFamily: 'Texta-book', fontSize: '19px !important', fontWeight: 'bold', lineHeight: '1.5px' }}>{language.overAllCost}</TableCell>
                            <TableCell sx={{ border: "1px  solid", fontFamily: 'Texta-book', fontSize: '19px !important' }}> ${twoDigitdecNum(sharePrecal?.[item.id]?.[0]?.totalAmount)}</TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Box>
                    }
                  </Grid>
                ))}
              </Grid>
              {/* {isPreCalEmpty ?
                <span className="dh-txt-danger" style={{fontSize:'20px', marginLeft: '18px',}}> <i className="fa fa-info-circle"></i> Precalculation data should not be empty</span>
              : */}
              {isError && (
                <span ref={errorRef} className="dh-txt-danger"  role="alert" aria-live="assertive"style={{fontSize:'20px', marginLeft: '18px',}}> <i className="fa fa-info-circle"></i> {errorMsg}</span>
              )}
            </Grid>
            {shwoMnthlyTxt ? (
              <TableRow >
                <TableCell sx={{ borderStyle: "none", width: "900px" }}>
                  <Grid p={2} sx={{ borderRadius: "5px", backgroundColor: "#DBE8DF", fontSize: "20px", fontFamily: 'Texta-bold', marginTop: "-20px" }}>
                    <Typography className="snap-title">{language.upcomingMonthlyCSA}</Typography>
                    <Divider sx={{ borderWidth: 1, backgroundColor: "#006e52", width: '70px' }} />
                    <Grid sx={{ display: 'flex', flexDirection: 'row' }}><Typography sx={{
                        fontFamily: 'Texta-book', fontSize: '20px', fontWeight: 400,
                        lineHeight: "1.5"
                      }}>{props?.farmInfo?.farmDetails?.isHIPVendor === "N" ? language.payWithSNAP : language.payWithSNAPHIP}</Typography><Typography className="snap-info">&nbsp;${twoDigitdecNum(mnthlyCost)}</Typography></Grid>                 
                  </Grid>
                </TableCell>
              </TableRow>
            ) : ""}
            {shwoMnthlyTxt && props?.farmInfo?.farmDetails?.isHIPVendor === "Y" ? (
              <TableRow >
                <TableCell sx={{ borderStyle: "none", width: "900px" }}>
                  <Grid p={2} sx={{ borderRadius: "5px", backgroundColor: "#DBE8DF", fontSize: "20px", fontFamily: 'Texta-bold',  marginTop: "-20px" }}>
                    <Typography  className="snap-title">{language.amountOfHIP} = <span className="snap-info">${parseFloat(mnthlyCost) > parseFloat(clientInfo?.hipAmount) ? twoDigitdecNum(clientInfo?.hipAmount) : twoDigitdecNum(mnthlyCost)} 
                      <IconButton aria-label={language.amountOfHIPMoreInfo} style={{fontSize:'14px', padding:'0px'}} className="tooltip" tabIndex={0}><HelpIcon className="green-color cursor-pointer" />
                        <span className="tooltiptext">{language.amountOfHIPMoreInfo}</span>
                      </IconButton></span></Typography>  
                                  
                  </Grid>
                </TableCell>
              </TableRow>
            ) : ""}
          </Row>
          <Grid container direction="row" justifyContent="flex-end" sx={{ border: '1px solid rgba(0, 0, 0, 0.125)', borderTop: 'none', backgroundColor: "#EEEEEE", height: '80px' }}>
            <TableCell>
              <Grid >
                <Button aria-label="previous" onClick={() => {
                               if (userRole.Role === "ADMIN") {
                                if (isShareRowEdit && Object.keys(isShareRowEdit).length) {
                                 const isShareNotSave = Object.values(isShareRowEdit).some(item => item === true);
                                 if (isShareNotSave) {
                                   popUpAlert({
                                     text: 'Please save the edited Share Information',
                                     icon: 'warning',
                                     timer: '2500'
                                   });
                                   return false;
                                 } 
                                }else if(isDaily) {
                                  return false;
                                }
                                else {
                                  props.setActiveTab("menuStep2");
                                  submitShareForm(getValues(), false);
                                  props.setVendorChange(false);
                                }
                              } else {
                                  props.setActiveTab("menuStep2");
                                  submitShareForm(getValues(), false);
                                  props.setVendorChange(false);
                              }
                }} sx={{
                  backgroundColor: '#ffffff', color: '#006E52', height: '50px', width: '100px', borderColor: '#006E52', border: 'solid', borderWidth: '1px', '&:hover': {
                    backgroundColor: '#006E52',
                    color: '#ffffff',
                  },
                  '&:active': {
                    backgroundColor: '#006E52',
                    color: '#ffffff',
                  },
                }}>
                  <ArrowBackIosNewIcon /> {language.Prev}
                </Button>
                <Button
                  sx={{ backgroundColor: '#006E52 !important', color: 'white', height: '50px', width: '120px', marginLeft: '10px' }}
                  type="submit" value="Submit"> {language.Next} <ArrowForwardIosIcon /></Button>
              </Grid>
            </TableCell>
          </Grid>
        </Box>
      </Grid>
    </Form>
  );
}
SnapShareComponent.propTypes = {
  setActiveTab: PropTypes.func,
  getClientInfo: PropTypes.func.isRequired,
  getCSAShareList: PropTypes.func.isRequired,
  getClientAgrmntShrLst: PropTypes.func.isRequired,
  getSnapShare: PropTypes.func,
  csaSignup: PropTypes.object.isRequired,
  activeMenu: PropTypes.object,
  handleUpdate: PropTypes.func,
  setSelectedShares: PropTypes.func,
  setShareGetValues: PropTypes.func,
  shareGetValues: PropTypes.object,
  clientInfo: PropTypes.object,
  getRequestHelp: PropTypes.func,
  farmInfo: PropTypes.object,
  setCSAFormValidate: PropTypes.func.isRequired,
  shareDetails: PropTypes.func,
  setTotalShareCost: PropTypes.func,
  selectedShare: PropTypes.array,
  saveCSASignup: PropTypes.func,
  setSharePrecal: PropTypes.func,
  sharePrecal: PropTypes.object,
  vendorChange: PropTypes.bool,
  setVendorChange: PropTypes.func,
  setIsShareRowEdit: PropTypes.object,
  userAuth: PropTypes.object.isRequired,
  setAllSharePrecal: PropTypes.func,
  signupLanguage: PropTypes.object,
}
function mapDispatchToProps(dispatch) {
  return {
    getCSAShareList: (sharePayload) => dispatch(actionType.getCSAShareList(sharePayload)),
    getClientAgrmntShrLst: (payload) => dispatch(actionType.getClientAgrmntShrLst(payload)),
    getSnapShare: (Payload) => dispatch(actionType.getSnapShare(Payload)),
    getRequestHelp: (Payload) => dispatch(actionType.getRequestHelp(Payload)),
    getClientInfo: (payload) => dispatch(actionType.getClientInfo(payload)),
    saveCSASignup: (csaSignupForm) => dispatch(actionType.saveCSASignup(csaSignupForm)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SnapShareComponent);